<template>
    <Main>
        <router-view />
    </Main>      
</template>

<script setup lang="ts">
    import { onMounted } from "vue";
    import Main from "@/app/views/app/main.vue";
    import router from "@app/router";
    import { useAppStore } from "@/app/store/app/app-store";
    import { usePublicStore } from "@/app/store/public/public-store";
    import { commClient } from "fw4-library";
    import { useDataEditingStore } from "@/app/store/app/settings/settings-store";
    import { provide } from "vue";


    const appStore = useAppStore();
    const publicStore = usePublicStore();
    const dataEditingStore = useDataEditingStore();

    publicStore.Login.Password = "";
    publicStore.Registration.Password = "";
    publicStore.Registration.RepeatPassword = "";
    publicStore.PublicHelpers.ServerError = ''; 

    const authenticationFailed = (): void => {
        console.log("error-auth");
        // router.push({name: "home"});
    };

    onMounted(async () => {
        commClient.OnWebSocketAuthenticationFailed.AddCallback(authenticationFailed);
        try {
            await commClient.connectWebSockets();

            console.log("WebSockets connected.");

            appStore.postalCode();
            appStore.choseCountry();
            dataEditingStore.UserDataLoad();
        }
        catch (e) {
            console.error("WebSocket connection or initialization failed.", e);
        }
    });

    provide("commClient", commClient);
</script>
